import styled from 'styled-components'

export const Wrapper = styled.div<{ width: string; margin: string }>`
	position: relative;
	display: flex;
	flex-flow: column;
	width: 100%;
	margin: var(--mg-xs) 0px;
	margin-top: ${(props) => (props.margin ? props.margin : '')};
`

export const Input = styled.input`
	background-color: transparent;
	padding-left: 10px;
	letter-spacing: 0.15px;
	height: var(--it-hg-lg);
	border: 0px;
	border-bottom: 1px solid var(--border-color);
	color: var(--text-white-color);
	font-size: var(--fs-sm);
	font-weight: var(--fw-sm);
	margin: 0px 20px;
	&:focus {
		outline: none;
	}
	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	&::placeholder {
		color: var(--placeholder-color);
		opacity: 1;
	}

	&::-ms-input-placeholder {
		color: var(--placeholder-color);
	}
`

export const ErrorMessage = styled.span`
	align-self: start;
	color: var(--btn-color);
	font-size: var(--fs-xxs);
	margin-top: var(--mg-xs) !important;
	margin: 0px 20px;
`
